import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { Img } from '../../ui-kit/Img/Img.js';
import { Paragraph } from '../../ui-kit/Paragraph/Paragraph.js';
import { Text } from '../../ui-kit/Text/Text.js';
export const SafeDepositRentalTotal = JSX(({ days, tariffs = [] }) => {
    const price = calculatePrice(days, tariffs);
    const imageDescription = 'На рисунке изображена пачка листов\nформата А4';
    return (_jsxs("div", { className: "contents @xl:flex flex-col justify-between gap-xl order-2", children: [_jsxs("div", { className: "flex flex-col @xl:flex-row gap-x-6xl gap-y-2xl order-5 @xl:order-none py-2xl @xl:py-0 border-t border-main-divider @xl:border-none", children: [renderTotal('Аренда за', days), renderTotal('Цена', price + ' ₽')] }), _jsx("div", { className: "@xl:hidden order-3 mb-xs", children: _jsx(Paragraph, { size: "text-s", font: "font-light", color: "text-secondary-text", children: imageDescription }) }), _jsxs("div", { className: "flex flex-col items-center gap-s order-3 @xl:order-none mb-xl @xl:mb-0 bg-primary-main py-s @xl:p-3xl text-center", children: [_jsx(Img, { image: { icon: 'PackA4Icon' }, className: "@xl:h-60" }), _jsx("div", { className: "hidden @xl:inline opacity-80 whitespace-pre-line", children: _jsx(Paragraph, { size: "text-s", font: "font-light", color: "text-white", children: imageDescription }) })] })] }));
});
const renderTotal = (label, total) => (_jsxs("div", { className: "flex justify-between items-center gap-y-xs @xl:flex-col @xl:items-start", children: [_jsx(Text, { size: "text-l", font: "font-light", color: "text-secondary-text", children: label }), _jsx("span", { className: "text-l @xl:text-h3 text-primary-text", children: total })] }));
const calculatePrice = (days, tariffs) => {
    const tariffType = getTariffType(days);
    const tariffValue = tariffs?.find((_) => _.tariffType === String(tariffType))?.tariffValue || 0;
    return days * tariffValue;
};
const getTariffType = (days) => {
    let tariffType = 1;
    switch (true) {
        case days > 30 && days <= 90:
            tariffType = 2;
            break;
        case days > 90 && days <= 180:
            tariffType = 3;
            break;
        case days > 180 && days <= 365:
            tariffType = 4;
            break;
    }
    return tariffType;
};
//# sourceMappingURL=SafeDepositRentalTotal.js.map